import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { readBehaviorOptions, maxConcurrentConnectionsMetadata } from '../consts/metadata-consts';
import { writeBehaviorOptionValues, writeBehaviorAllOptions } from 'app/shared/constants/write-behavior.const';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { getConnectorV1Name, getConnectorV2Name } from 'shell-models-lib';

const salesforceSinkWriteBehaviors = [writeBehaviorOptionValues.insert, writeBehaviorOptionValues.upsert];
export const writeBehavior: ControlMetadata = {
    type: 'select-switch',
    bind: 'writeBehavior',
    label: stringResources.ModelName_WriteBehavior,
    defaultValue: writeBehaviorOptionValues.insert,
    options: writeBehaviorAllOptions
        .filter((option) => salesforceSinkWriteBehaviors.indexOf(option.value) >= 0),
    isLabelVertical: false,
    returnAllChildrenProperties: true,
    cases: [
        {
            caseValue: writeBehaviorOptionValues.upsert,
            children: [
                {
                    type: 'parameterizable',
                    child: {
                        type: 'textbox',
                        bind: 'externalIdFieldName',
                        label: stringResources.ModelName_SalesforceExternalIdFieldName,
                        description: stringResources.SalesforceExternalIdFieldNameDescription,
                        required: true
                    },
                    dynamicContentTextClass: 'input-spaced'
                }
            ]
        }
    ]
};
export const ignoreNullValues: ControlMetadata = {
    type: 'parameterizable',
    child: {
        type: 'checkbox',
        bind: 'ignoreNullValues',
        label: stringResources.ModelName_IgnoreNullValues,
        description: stringResources.IgnoreNullValuesDescription
    },
    dynamicContentTextClass: 'input-spaced'
}

export const salesforceObjectMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.salesforce.datasetType,
    disabled: __IS_FABRIC_DPE__,
    displayName: getConnectorV1Name(stringResources.Salesforce_DisplayText),
    supportLinkedServiceTypes: [adfModelTypeMap.salesforce.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Salesforce'
    },
    tableNameDisplay: stringResources.TableNameDisplay_ObjectApiName,
    tableNamePlural: stringResources.TableNameDisplay_ObjectApiNames,
    queryTooltipLink: 'https://docs.microsoft.com/azure/data-factory/connector-salesforce#query-tips',
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        getConnectorV2Name(stringResources.Salesforce_DisplayText)
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-salesforce?tabs=data-factory',
    v1SupportSchema: true,
    category: ['ServicesApps'],
    copySourceControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'readBehavior',
            label: stringResources.ReadBehaviorLabel,
            isLabelVertical: false,
            options: readBehaviorOptions,
            defaultValue: 'query'
        }
    ],
    copySinkControls: [
        writeBehavior,
        ignoreNullValues,
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                defaultValue: 5000,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata
    ]
};
